import http from 'config/http';

import { ClientModel, IUserPreference, UserModel } from 'api/models';
import { IPasswordPayload, IProfilePayload } from 'api/types';
import { getApiUrl } from 'config/api-url';

export const getCurrentAccount = async () => {
    const { data } = await http.get(`${getApiUrl()}/account/user`);

    const { client, ...rest } = data;

    return { user: UserModel.fromObject(rest), client: ClientModel.fromObject(client) };
};

export const getProfile = async () => {
    const { data } = await http.get(`${getApiUrl()}/account`);

    return UserModel.fromObject(data);
};

export const updateProfile = async (payload: IProfilePayload) => {
    await http.put(`${getApiUrl()}/account`, payload);

    // return UserModel.fromObject(data) as Partial<UserModel>;
};

export const updateTeams = async (tags: string[]) => {
    await http.put(`${getApiUrl()}/account/tags`, { tags });

    // return UserModel.fromObject(data) as Partial<UserModel>;
};

export const updateDp = async (payload: FormData, config: { onUploadProgress?: (progress: number) => void }) => {
    const { data } = await http.put(`${getApiUrl()}/account/dp`, payload, {
        onUploadProgress: (progressEvent) => {
            const progress = (progressEvent.loaded / progressEvent.total) * 100;

            config?.onUploadProgress?.(Math.trunc(progress));
        },
    });

    return { dpUrl: data.dpUrl } as Pick<UserModel, 'dpUrl'>;
};

export const removeDp = async () => {
    await http.delete(`${getApiUrl()}/account/dp`);
};

export const updatePreferences = async (preferences: Partial<UserModel['preferences']>) => {
    await http.put(`${getApiUrl()}/account/preferences`, { ...preferences });
};

export const updatePreferencesSiteWalkMedia = async (payload: Pick<UserModel['preferences'], 'siteWalkViewType'>) => {
    await http.put(`${getApiUrl()}/account/preferences/site-walk-media-view`, payload);
};

export const updatePrimaryColor = async (primaryColor: string) => {
    await http.put(`${getApiUrl()}/account/preferences/primary-color`, { primaryColor });
};

export const updateTheme = async (theme: string) => {
    await http.put(`${getApiUrl()}/account/preferences/theme`, { theme });
};

export const updatePassword = async (payload: IPasswordPayload) => {
    const { data } = await http.put(`${getApiUrl()}/account/password`, payload);
    return data as { token: string };
};

export const updateHiddenProjects = async (hiddenProjects: string[]) => {
    await http.put(`${getApiUrl()}/account/projects/hide`, { hiddenProjects });
};

export const deleteAccount = async () => {
    await http.delete(`${getApiUrl()}/account`);
};

export const updatePathPreference = async (payload: IUserPreference) => {
    await http.put(`${getApiUrl()}/account/preferences`, { ...payload });
};
